@if (selectedColorset; as colorset) {
  <div
    class="grid"
    *ngFor="let scaleControl of legendFormArray.controls; let i = index"
    [formGroup]="getLegendGroup(i)">
    <!-- Color Indicator -->
    <app-form-field-wrapper [colSize]="'fixed'" [hideLabel]="true">
      <i
        class="fas fa-circle"
        [style]="
          'padding: 1rem 0 0 1rem; color:' +
          colorset.colors[invert ? colorset.colors.length - 1 - i : i]
        "></i>
    </app-form-field-wrapper>

    <!-- Input Fields -->
    <app-form-field-wrapper [label]="'Von'" [name]="'from'" [colSize]="2">
      <input formControlName="from" pInputText type="text" class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper [label]="'Bis'" [name]="'to'" [colSize]="2">
      <input formControlName="to" pInputText type="text" class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [label]="'Beschriftung'"
      [name]="'text'"
      [colSize]="7">
      <input formControlName="text" pInputText type="text" class="p-input" />
    </app-form-field-wrapper>
  </div>
}
